import { EmptyState, FlexColumn, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../constants/app';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import {
  groupIdsState,
  groupsPageState,
  groupsState,
  loadingGroupsState,
  selectedGroupIdState,
} from '../../storage/groups';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import GroupFilters from './GroupFilters';
import GroupItem from './GroupItem';

export function GroupList() {
  const { css } = useStyles();
  const groupIds = useRecoilValue(groupIdsState);
  const setSelectedGroupId = useSetRecoilState(selectedGroupIdState);
  const resetSelectedGroupId = useResetRecoilState(selectedGroupIdState);
  const loadingGroups = useRecoilValue(loadingGroupsState);
  const paginatedGroups = useRecoilValue(groupsState);
  const setGroupsPage = useSetRecoilState(groupsPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedGroupId();
    };
  });

  const onNewGroup = () => {
    setSelectedGroupId('');
  };

  return (
    <FlexColumn classNames={css({ height: '100%' })}>
      {!groupIds && !loadingGroups && <EmptyState title="Todavía no creas ningun grupo" />}
      {!groupIds && loadingGroups && <Loading />}
      {groupIds && (
        <>
          <GroupFilters />
          <VirtualizedPaginatedList
            ids={groupIds}
            loading={loadingGroups}
            onNextPage={setGroupsPage}
            paginatedResponse={paginatedGroups}
            itemComponent={GroupItem}
            itemSize={SMALL_LIST_ITEM_HEIGHT}
          />
          {!groupIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(groupIds || !loadingGroups) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewGroup}
          startEnhancer={<MaterialIcon name={'add'} />}
          kind="tertiary"
        >
          Nuevo grupo
        </StyledButton>
      )}
    </FlexColumn>
  );
}
